import React from 'react';
import {
    Box, CircularProgress, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Chip, Typography
} from '@material-ui/core';
import { WhatsAppRechargeType } from 'api/whatsapp/types';
import { IApiState } from 'store/types';
import { apiStatus } from 'shared/constants/AppEnum';
import HeadingCard from 'components/Card/HeadingCard';

interface RechargeTableProps {
    recharges: WhatsAppRechargeType[];
    api: IApiState;
}

const getStatusColor = (status: string): 'default' | 'primary' | 'secondary' => {
    switch (status) {
        case 'completed': return 'primary';
        case 'failed': return 'secondary';
        default: return 'default';
    }
};

const RechargeTable: React.FC<RechargeTableProps> = ({ recharges, api }) => {
    return (
        <HeadingCard title="Recharge History" cardContent={false} hasheaderBackground={false}>
            {api.status === apiStatus.LOADING ? (
                <Box display="flex" justifyContent="center" py={4}>
                    <CircularProgress />
                </Box>
            ) : recharges.length === 0 ? (
                <Box textAlign="center" my={4}>
                    <Typography color="textSecondary">No recharges found</Typography>
                </Box>
            ) : (
                <TableContainer component={Paper} elevation={0}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Package</TableCell>
                                <TableCell>Credit Type</TableCell>
                                <TableCell align="right">Amount</TableCell>
                                <TableCell align="right">Credits</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Order ID</TableCell>
                                <TableCell>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {recharges.map((recharge) => (
                                <TableRow key={recharge.id}>
                                    <TableCell>{recharge.package_name}</TableCell>
                                    <TableCell>{recharge.credit_type_display}</TableCell>
                                    <TableCell align="right">₹{recharge.amount}</TableCell>
                                    <TableCell align="right">{recharge.credits}</TableCell>
                                    <TableCell>
                                        <Chip
                                            label={recharge.status_display}
                                            color={getStatusColor(recharge.status)}
                                            size="small"
                                        />
                                    </TableCell>
                                    <TableCell>{recharge.order_id}</TableCell>
                                    <TableCell>
                                        {new Date(recharge.created_at).toLocaleDateString()}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </HeadingCard>
    );
};

export default RechargeTable;
